import { useState } from "react";
import PropTypes from "prop-types";
import useInterval from "../hooks/useInterval";

const Countdown = ({ start, end }) => {
  const [timeLeft, setTimeLeft] = useState(start);

  useInterval(
    () => {
      setTimeLeft(timeLeft => timeLeft - 1000);
    },
    timeLeft > end ? 1000 : null
  );

  return timeLeft / 1000;
};

Countdown.propTypes = {
  start: PropTypes.number.isRequired,
  end: PropTypes.number
};

Countdown.defaultProps = {
  end: 0
};

export default Countdown;
